<template>
  <div v-if="alert" class="px-4 pt-16 max-w-screen-2xl mx-auto">
    <div
      class="w-full px-8 py-4 rounded-lg bg-secondary-500 text-white lg:flex lg:items-center lg:justify-between"
    >
      <div class="text-left pr-8">{{ alert.text }}</div>
      <div class="mt-8 lg:mt-0">
        <BaseButton
          class="btn-secondary"
          :href="alert.link"
          :blank="alert.target_blank"
        >
          {{ alert.button }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('home', ['alert']),
  },
}
</script>
